<footer role="contentinfo" class="footer">
  <app-footer-logos></app-footer-logos>

  <section role="region" class="footer__about">
    <h2 role="heading" id="footer-about">
      <ng-container *ngIf="(isMobile$ | async) === false">À Propos</ng-container>

      <button
        *ngIf="(isMobile$ | async) === true"
        class="btn-clean footer__about__expand-btn"
        type="button"
        [attr.aria-expanded]="(isMobile$ | async) === false || !isCollapsed.about"
        aria-controls="footer-about-links"
        (click)="isCollapsed.about = !isCollapsed.about"
      >
        À Propos
        <mat-icon svgIcon="arrow_next" aria-label="Afficher la section À Propos"></mat-icon>
      </button>
    </h2>

    <ul
      id="footer-about-links"
      class="footer__about__list"
      aria-labelledby="footer-about"
      [attr.expanded]="(isMobile$ | async) === false || !isCollapsed.about"
    >
      <li>
        <a
          class="link"
          [routerLink]="['/', FeaturesRoutingEnum.CGU]"
          (click)="trackEvent({ category: 'Footer', action: 'Click CGU', type: 'navigation' })"
          >CGU</a
        >
      </li>
      <li>
        <a
          class="link"
          [routerLink]="['/', FeaturesRoutingEnum.LegalMentions]"
          (click)="trackEvent({ category: 'Footer', action: 'Click Mentions légales', type: 'navigation' })"
          >Mentions légales</a
        >
      </li>
      <li>
        <a
          class="link"
          [routerLink]="['/', FeaturesRoutingEnum.Privacy]"
          (click)="trackEvent({ category: 'Footer', action: 'Click Confidentialité', type: 'navigation' })"
          >Politique de confidentialité</a
        >
      </li>
      <li>
        <a
          class="link"
          [routerLink]="['/', FeaturesRoutingEnum.Accessibility]"
          (click)="trackEvent({ category: 'Footer', action: 'Click Accessibilité', type: 'navigation' })"
          >Accessibilité</a
        >
      </li>

      <li>
        <button
          type="button"
          class="btn-clean btn-link"
          (click)="
            openCookiesModal(); trackEvent({ category: 'Footer', action: 'Click Gestion des cookies', type: 'action' })
          "
        >
          Gestion des cookies
        </button>
      </li>
    </ul>
  </section>

  <section role="region" class="footer__links">
    <h2 role="heading" id="plan-links">
      <ng-container *ngIf="(isMobile$ | async) === false">
        <a
          class="link--primary"
          [routerLink]="['/', FeaturesRoutingEnum.Sitemap]"
          (click)="trackEvent({ category: 'Footer', action: MenuTrackEventsEnum.Sitemap, type: 'navigation' })"
        >
          Plan du site
        </a>
      </ng-container>

      <button
        *ngIf="(isMobile$ | async) === true"
        class="btn-clean footer__links__expand-btn"
        type="button"
        [attr.aria-expanded]="(isMobile$ | async) === false || !isCollapsed.plan"
        aria-controls="plan-links-links"
        (click)="isCollapsed.plan = !isCollapsed.plan"
      >
        Plan du site
        <mat-icon svgIcon="arrow_next" aria-label="Afficher la section Liens Utiles"></mat-icon>
      </button>
    </h2>

    <ul
      id="plan-links-links"
      class="footer__links__list"
      aria-labelledby="plan-links"
      [attr.expanded]="(isMobile$ | async) === false || !isCollapsed.plan"
    >
      <li>
        <a
          class="link"
          [routerLink]="['/']"
          ignoreExternLink
          (click)="trackEvent({ category: 'Footer', action: MenuTrackEventsEnum.Accueil, type: 'navigation' })"
        >
          Accueil
        </a>
      </li>

      <li *ngFor="let menuItem of MENU; trackBy: trackByMenuItem">
        <a
          [routerLink]="menuItem.siteMapFooterLink"
          class="link"
          (click)="trackEvent({ category: 'Footer', action: menuItem.trackEventAction, type: 'navigation' })"
          >{{ menuItem.label }}</a
        >
      </li>
      <li *ngIf="(isMobile$ | async) === true">
        <a
          class="link"
          [routerLink]="['/', FeaturesRoutingEnum.Sitemap]"
          (click)="trackEvent({ category: 'Footer', action: MenuTrackEventsEnum.Sitemap, type: 'navigation' })"
          >Plan du site</a
        >
      </li>
      <li>
        <a class="link" [routerLink]="['/', FeaturesRoutingEnum.Partners]">Partenaires</a>
      </li>
      <li>
        <button
          type="button"
          class="btn-clean btn-link"
          (click)="contactUs.emit(); trackEvent({ category: 'Footer', action: 'Click Contact', type: 'action' })"
        >
          Nous contacter
        </button>
      </li>
    </ul>
  </section>

  <section role="region" class="footer__links footer__links--last">
    <h2 role="heading" id="footer-links">
      <ng-container *ngIf="(isMobile$ | async) === false">Liens Utiles</ng-container>

      <button
        *ngIf="(isMobile$ | async) === true"
        class="btn-clean footer__links__expand-btn"
        type="button"
        [attr.aria-expanded]="(isMobile$ | async) === false || !isCollapsed.links"
        aria-controls="footer-links-links"
        (click)="isCollapsed.links = !isCollapsed.links"
      >
        Liens Utiles
        <mat-icon svgIcon="arrow_next" aria-label="Afficher la section Liens Utiles"></mat-icon>
      </button>
    </h2>

    <ul
      id="footer-links-links"
      class="footer__links__list"
      aria-labelledby="footer-links"
      [attr.expanded]="(isMobile$ | async) === false || !isCollapsed.links"
    >
      <li>
        <a
          class="link"
          href="https://www.gouvernement.fr/"
          target="_blank"
          (click)="trackEvent({ category: 'Footer', action: 'Click Gouvernement', type: 'navigation' })"
          >Gouvernement</a
        >
      </li>
      <li>
        <a
          class="link"
          href="https://travail-emploi.gouv.fr/"
          target="_blank"
          (click)="trackEvent({ category: 'Footer', action: 'Click Ministère travail', type: 'navigation' })"
          >Ministère du travail, de l&apos;emploi et de l&apos;insertion</a
        >
      </li>
      <li>
        <a
          class="link"
          href="https://www.pole-emploi.fr/accueil/"
          target="_blank"
          (click)="trackEvent({ category: 'Footer', action: 'Click Pôle emploi', type: 'navigation' })"
          >Pôle emploi</a
        >
      </li>
      <li>
        <a
          class="link"
          href="https://www.unml.info/les-missions-locales/annuaire/"
          target="_blank"
          (click)="trackEvent({ category: 'Footer', action: 'Click Missions locales', type: 'navigation' })"
          >Annuaire des missions locales</a
        >
      </li>
      <li>
        <a
          class="link"
          href="https://www.service-civique.gouv.fr/"
          target="_blank"
          (click)="trackEvent({ category: 'Footer', action: 'Click Service Civique', type: 'navigation' })"
          >Service Civique</a
        >
      </li>
      <li>
        <a
          class="link"
          href="https://www.france.fr/"
          target="_blank"
          (click)="trackEvent({ category: 'Footer', action: 'Click France', type: 'navigation' })"
          >France</a
        >
      </li>
    </ul>
  </section>
</footer>
